export enum Country {
  Spain = 'es',
  France = 'fr',
  Germany = 'de',
  Italy = 'it',
  // add more countries
}
